import React from "react";
import "./AISupplierProductCard.css";


const AISupplierProductCard = ({
    product,
    selectionMode = false,
    onSelect
}) => {

    if (!product) {
        return null;
    }

    const productName =
        product.product_name_english ||
        product.product_name ||
        "Unknown Product";

    const imageUrl =
        product.image_url ||
        null;


    // =========================================================
    // PRODUCT SELECTION CARD
    // =========================================================

    if (selectionMode) {

        const price =
            product.price ??
            product.price_per_unit ??
            null;

        const currency =
            product.currency ||
            "QAR";

        const unit =
            product.unit ||
            product.unit_of_measure ||
            "";

        const stock =
            Number(
                product.stock ??
                product.stock_availability ??
                0
            );

        return (
            <div className="ai_supplier_product_card">

                <div className="ai_supplier_product_image_wrapper">

                    {imageUrl ? (
                        <img
                            src={imageUrl}
                            alt={productName}
                            className="ai_supplier_product_image"
                        />
                    ) : (
                        <div className="ai_supplier_product_image_placeholder">
                            No Image
                        </div>
                    )}

                </div>

                <div className="ai_supplier_product_content">

                    <h4 className="ai_supplier_product_name">
                        {productName}
                    </h4>

                    {price !== null && (
                        <div className="ai_supplier_stat">

                            <span className="ai_supplier_stat_label">
                                Price
                            </span>

                            <span className="ai_supplier_stat_value">
                                {currency} {Number(price).toLocaleString()}
                                {unit ? ` / ${unit}` : ""}
                            </span>

                        </div>
                    )}

                    <div className="ai_supplier_stat">

                        <span className="ai_supplier_stat_label">
                            Stock
                        </span>

                        <span className="ai_supplier_stat_value">
                            {stock.toLocaleString()}
                        </span>

                    </div>

                    <button
                        type="button"
                        className="ai_supplier_select_button"
                        onClick={onSelect}
                    >
                        View Sales
                    </button>

                </div>

            </div>
        );
    }


    // =========================================================
    // ANALYTICS CARD
    // =========================================================

    const unitsSold =
        Number(product.units_sold || 0);

    const orderCount =
        Number(product.order_count || 0);

    const revenue =
        Number(product.revenue || 0);

    const rank =
        product.rank || 0;


    return (
        <div className="ai_supplier_product_card">

            <div className="ai_supplier_product_image_wrapper">

                {imageUrl ? (
                    <img
                        src={imageUrl}
                        alt={productName}
                        className="ai_supplier_product_image"
                    />
                ) : (
                    <div className="ai_supplier_product_image_placeholder">
                        No Image
                    </div>
                )}

            </div>

            <div className="ai_supplier_product_content">

                <div className="ai_supplier_rank">
                    #{rank}
                </div>

                <h4 className="ai_supplier_product_name">
                    {productName}
                </h4>

                <div className="ai_supplier_sales_info">

                    <div className="ai_supplier_stat">

                        <span className="ai_supplier_stat_label">
                            Units Sold
                        </span>

                        <span className="ai_supplier_stat_value">
                            {unitsSold.toLocaleString()}
                        </span>

                    </div>

                    <div className="ai_supplier_stat">

                        <span className="ai_supplier_stat_label">
                            Orders
                        </span>

                        <span className="ai_supplier_stat_value">
                            {orderCount.toLocaleString()}
                        </span>

                    </div>

                    <div className="ai_supplier_stat">

                        <span className="ai_supplier_stat_label">
                            Revenue
                        </span>

                        <span className="ai_supplier_stat_value">
                            QAR {revenue.toLocaleString()}
                        </span>

                    </div>

                </div>

                <div className="ai_supplier_product_badge">
                    Best Seller
                </div>

            </div>

        </div>
    );
};


export default AISupplierProductCard;
